import { useEffect, useRef, useState } from 'react'
import styles from './index.module.less'
import LoadingImg from '@/assets/image/gea/loading.png'
const LoadingCom = () => {
  const [show, setShow] = useState<boolean>(false)
  const timeId = useRef<NodeJS.Timeout | null>(null)
  useEffect(() => {
    timeId.current = setTimeout(() => {
      setShow(true)
    }, 100)
    return () => {
      if (timeId.current) {
        clearTimeout(timeId.current)
      }
    }
  }, [])
  return (
    <>
      {show ? (
        <div className={styles.loading_container}>
          <p className={styles.loading_img}>
            <img src={LoadingImg} alt="" />
          </p>
        </div>
      ) : (
        ''
      )}
    </>
  )
}

export default LoadingCom
